import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    var carouselPercentage = 0;

    if ($element.find('.walk-scroller-carousel')) {
      const walkScrollerCarousel = new Flickity($element.find('.walk-scroller-carousel').get()[0], {
        // adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: 'left',
        groupCells: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue

            // Set the width of the scroller based on the number of carousel items
            if (this.slides) {
              const carousel = this;

              setTimeout(() => {
                let carouselItems = carousel.slides.length;
                carouselPercentage = (1 / carouselItems) * 100;
                $element.find('.progress-slider-wrap .progress-slider-inner').css({ width: carouselPercentage.toString() + '%' });
              }, 500);
            }
          },
        },
      });

      // Set a tab index of negative -1 for all CTA's that are hidden from view.
      $element.find('.walk-scroller-carousel').
      find('.carousel-cell').
      each(function(e) {
        if ($(this).attr('aria-hidden') === 'true') {
          $(this).find('.walk-link').attr('tabindex', -1);
        }
      });

      // Scroll buttons
      $element.find('.progress-slide-arrow-prev').on('click', function() {
        walkScrollerCarousel.previous();
      });

      $element.find('.progress-slide-arrow-next').on('click', function(i) {
        walkScrollerCarousel.next();
      });

      walkScrollerCarousel.on('change', function(i) {
        if (i == 0) {
          $element.find('.progress-slide-arrow-prev').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-prev').removeClass('disabled');
        }

        if (i + 1 >= walkScrollerCarousel.slides.length) {
          $element.find('.progress-slide-arrow-next').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-next').removeClass('disabled');
        }

        const scrollPosition = carouselPercentage * walkScrollerCarousel.selectedIndex;
        $element.find('.progress-slider-wrap .progress-slider-inner').css({ left: scrollPosition.toString() + '%' });

        // Set a tab index of negative -1 for all CTA's that are hidden from
        // view. If a cell is not hidden from view, then make the cell
        // tabbable by removing the negative tab index to re-enable it in the
        // DOM.
        $element.find('.walk-scroller-carousel').
        find('.carousel-cell').
        each(function(e) {
          if ($(this).attr('aria-hidden') === 'true') {
            $(this).find('.walk-link').attr('tabindex', -1);
          } else {
            $(this).find('.walk-link').removeAttr('tabindex');
          }
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/shared/walkScroller.js